import {Component, Input} from "@angular/core";
import {NgClass} from "@angular/common";

@Component({
  selector: 'box-item-flip',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: 'box-item-flip.html',
  styleUrl: 'box-item-flip.scss'
})
export class BoxItemFlip {
  @Input() title: string;
  @Input() description: string;
  @Input() content: string;
  @Input() imgClass: string;
  @Input() url?: string;

  constructor() {}

  handleClick(event: Event) {
    if (!this.url) return;
    window.open(this.url, '_blank');
  }
}
